import React from 'react';
import { Box, BoxProps, styled, Typography } from '@mui/material';

interface Props extends BoxProps {
  icon: React.ReactNode;
  title: string;
  desc: string;
}

const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: 10,

  '& + &': {
    marginTop: theme.spacing(2),
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20,
    color: theme.palette.primary.main,
  },
}));

const FeatureItem: React.FC<Props> = ({ icon, title, desc }) => {
  return (
    <Wrapper>
      <Box mt={0.25}>{icon}</Box>
      <Box>
        <Typography variant="body1" fontWeight={500}>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {desc}
        </Typography>
      </Box>
    </Wrapper>
  );
};

export default FeatureItem;
